import * as DataStore from "data/DataStore";
import { getPrimaryIsbn } from "data/TitleInfoSelector";
import { getNovSchema } from "../../../utility";


function createLexileRangeNovelistLink(linkTemplate, lowerLexile, upperLexile, audienceLevel) {
	let query = `LX+${lowerLexile}-${upperLexile}+AND+RL+"${audienceLevel}"`;
	let novelistLexileLink = linkTemplate.replace("{query}",query);

	return encodeURI(novelistLexileLink);
}

class SearchByLexileRangeUrl {
	/**
	 * SearchByLexileRangeUrl models the api endpoint for fetching books based on lexile range
	 * @param {object} lexileRange JS object with lower and upper bounds on the lexile range.
	 * @param {string} readingLevel String representation of the reading/audience level for the book
	 */
	constructor(lexileRange, readingLevel) {
		this.lowerLexileScore = lexileRange.lowerLexileScore;
		this.upperLexileScore = lexileRange.upperLexileScore;
		this.readingLevel = readingLevel;
	}
	/**
	 * Generate the Api endpoint that will be called
	 */
	generateUrl() {
		let profileInfo = DataStore.getProfileData();
		let isbnToExclude = getPrimaryIsbn(DataStore.getJsonData());

		const apiEndpoint = `${getNovSchema()}${window.novSelect.baseUrl || DataStore.getBaseUrl()}/api/lexile/ByRange?`;
		const customerInfo = `profile=${profileInfo.Profile}&password=${profileInfo.Password}`;
		const searchTerms = `&lower=${this.lowerLexileScore}&upper=${this.upperLexileScore}&readingLevel=${this.readingLevel}`;
		const searchTermsToExclude = `&isbnToExclude=${isbnToExclude}`;
		const customLinkReplacements = `${DataStore.getCustLinks()}`;
		const url = `${apiEndpoint}${customerInfo}${searchTerms}${searchTermsToExclude}${customLinkReplacements}`;

		return encodeURI(url);
	}
}

export { createLexileRangeNovelistLink };
export default SearchByLexileRangeUrl;



// WEBPACK FOOTER //
// ./src/lib/titleSearch/lexileSearch/SearchByLexileRangeUrl.js